import Phonebook from "components/Phonebook/Phonebook";



export const App = () => {
  return (
  <>
  <Phonebook />
  </>
  );
};
